<nz-modal
  [(nzVisible)]="addInfo_open"
  [nzFooter]="null"
  [nzTitle]="modalTitle"
  (nzOnCancel)="cancelEvent.emit()"
  nzWidth="636px"
  [nzCloseIcon]="closeIcon"
>
  <ng-template #closeIcon>
    <img src="assets/icons/exit_new.svg" alt="close" />
  </ng-template>
  <ng-template #modalTitle>
    @if (infoTypeID() === 1) {
      {{ i18n.langString("info_equipment") }}
    } @else {
      <span class="black-coral-text">
        {{ i18n.langString("metadata_analytics") }}
      </span>
      <i
        nz-icon
        nzType="double-right"
        class="svg-icon svg-icon-tiny fillblackcoral"
      ></i>
      <div>{{ i18n.parse(infoTypeName()) }}</div>
    }
    <div
      class="additional-info-outer-wrapper"
      [class.mobile]="isMobile()"
      [class.tablet]="isTablet()"
    >
      @for (addInfoValue of addInfoList(); track trackByFn($index)) {
        <div
          class="input-area-wrapper input-area-wrapper-close additional-info-area"
        >
          @if (addInfoValue.infoTypeID === infoTypeID()) {
            <label for="plantNameInput" class="select-label regular">
              {{ addInfoValue.labelkey(i18n) }}
              @if (addInfoValue.optional) {
                <span class="silver-chalice-text"
                  >({{ i18n.langString("optional") }})</span
                >
              } @else {
                <span class="purple-alert-text"> *</span>
              }
            </label>

            <!-- Field Type Logic -->
            @switch (addInfoValue.fieldType) {
              @case ("single") {
                @if (addInfoValue.valueType) {
                  <!-- Numeric Input Section -->
                  <div
                    class="input-area input-close number"
                    [class.number-no-decimals]="addInfoValue.decimals === 0"
                    [class.error-input]="
                      !isDesktop() && showPopupErrormessage()
                        ? fieldInvalid(addInfoValue)
                        : null
                    "
                  >
                    <input
                      #numberInput
                      [(ngModel)]="addInfoValue.convertedValue"
                      oninput="
                        this.value = this.value
                          .replace(/[^0-9.]/g, '')
                          .replace(/[^\p{L}\p{N}\p{P}\p{Z}^$\n]/gu, '')
                          .replace(/(\..*?)\..*/g, '$1')
                      "
                      [maxlength]="100"
                      [min]="addInfoValue.minValue"
                      [max]="addInfoValue.maxValue"
                      (focus)="onFocusInEvent(addInfoValue)"
                      (blur)="onFocusOutEvent(addInfoValue)"
                      (ngModelChange)="refreshAddInfoList()"
                      [placeholder]="addInfoValue.parsedPlaceholder(i18n)"
                    />
                    <div class="input-inline">
                      <span
                        >{{ getUnitPrefix(addInfoValue.unitPrefix)
                        }}{{ getUnit(addInfoValue.unit) }}</span
                      >
                    </div>

                    <!-- Validation Hints -->
                    <div class="listHints info">
                      @if (
                        !(
                          addInfoValue.validations &&
                          addInfoValue.showValidation
                        )
                      ) {
                        @for (
                          validation of addInfoValue.defaultValidation;
                          track $index
                        ) {
                          @if (
                            !addInfoValue.showValidation &&
                            validation.showDefault
                          ) {
                            <div class="greyListHint">
                              <i
                                nz-icon
                                [nzType]="'icons:info'"
                                class="svg-icon"
                              ></i>
                              {{ i18n.Parse(validation.message) }}
                            </div>
                          }
                        }
                      } @else if (
                        addInfoValue.showValidation ||
                        fieldInvalid(addInfoValue)
                      ) {
                        @for (
                          validation of addInfoValue.validations;
                          track $index
                        ) {
                          @if (
                            addInfoValue.showValidation &&
                            isValid(addInfoValue, validation) &&
                            validation.validated
                          ) {
                            <div class="greenListHint">
                              <i
                                nz-icon
                                [nzType]="
                                  validation.type
                                    ? 'icons:info'
                                    : 'icons:done-full-circle'
                                "
                                class="svg-icon"
                              ></i>
                              {{ i18n.Parse(validation.message) }}
                            </div>
                          } @else if (
                            !isValid(addInfoValue, validation) &&
                            validation.validated
                          ) {
                            <div class="redListHint">
                              <i
                                nz-icon
                                nzType="icons:cross-circle"
                                class="svg-icon"
                              ></i>
                              {{ i18n.Parse(validation.message) }}
                            </div>
                          } @else if (
                            addInfoValue.showValidation && !validation.validated
                          ) {
                            <div class="greyListHint">
                              <i
                                nz-icon
                                [nzType]="
                                  validation.type
                                    ? 'icons:info'
                                    : 'icons:done-full-circle'
                                "
                                class="svg-icon"
                              ></i>
                              {{ i18n.Parse(validation.message) }}
                            </div>
                          }
                        }
                      }
                    </div>
                  </div>
                } @else {
                  <!-- Standard Text Input -->
                  <div class="input-area input-close text">
                    <input
                      #textInput
                      [(ngModel)]="addInfoValue.text"
                      [maxlength]="100"
                      (focus)="onFocusInEvent(addInfoValue)"
                      [placeholder]="addInfoValue.parsedPlaceholder(i18n)"
                      (ngModelChange)="refreshAddInfoList()"
                      oninput="
                        this.value = this.value.replace(
                          /[^\p{L}\p{N}\p{P}\p{Z}^$\n]/gu,
                          '',
                        )
                      "
                    />
                  </div>
                }
              }

              @case ("dropdown") {
                <app-select
                  [options]="addInfoValue.dropdownValues"
                  [(selected)]="addInfoValue.text"
                  [placeholder]="addInfoValue.parsedPlaceholder(i18n)"
                  [disabled]="addInfoValue.disabled"
                  [optional]="addInfoValue.optional"
                  (selectedChange)="onOptionsSelected(addInfoValue, $event)"
                  [class.streamTrap-content]="
                    !showRequiredHint() && isSteamTrap()
                  "
                ></app-select>
              }

              @case ("multiple") {
                @for (value of addInfoValue.multipleValues; track $index) {
                  <div class="input-area input-close multiple">
                    <input
                      [(ngModel)]="addInfoValue.multipleValues[$index]"
                      [maxlength]="100"
                      (focus)="onFocusInEvent(addInfoValue)"
                      [placeholder]="addInfoValue.parsedPlaceholder(i18n)"
                      (ngModelChange)="refreshAddInfoList()"
                      oninput="
                        this.value = this.value.replace(
                          /[^\p{L}\p{N}\p{P}\p{Z}^$\n]/gu,
                          '',
                        )
                      "
                    />
                    <div class="input-inline">
                      <button (click)="deleteFieldClick(addInfoValue, $index)">
                        <i nz-icon nzType="icons:delete"></i>
                      </button>
                    </div>
                  </div>
                }
                <app-nav-button
                  [darksecondary]="true"
                  [svgIcon]="'icons:pluscircle'"
                  (clickEvent)="addFieldClick(addInfoValue)"
                  [style]="
                    isDesktop()
                      ? 'align-self: center; margin-bottom: 24px;'
                      : 'align-self: center; margin-bottom: 16px;'
                  "
                >
                  {{ i18n.langString("add_field") }}
                </app-nav-button>
              }
            }

            <!-- Info Messages -->
            @if (addInfoValue.infoMessage?.length) {
              @for (message of addInfoValue.infoMessage; track $index) {
                <div class="input-area input-close info-message-wrapper">
                  <i
                    nz-icon
                    nzType="icons:info"
                    class="svg-icon fillblackcoral"
                  ></i>
                  <div>
                    <div class="detail-bold black-coral-text">
                      {{ i18n.parse(message.title) }}
                    </div>
                    <div class="detail black-coral-text">
                      {{ i18n.parse(message.message) }}
                    </div>
                  </div>
                </div>
              }
            }
          }
        </div>
      }

      @if (showRequiredHint()) {
        <div class="required-hint">
          <i nz-icon nzType="icons:info"></i>
          <div>
            <span class="detail-bold">{{
              i18n.langString("required_hint_1")
            }}</span>
            <span class="detail-bold purple-alert-text">*</span>
            <span class="detail-bold">{{
              i18n.langString("required_hint_2")
            }}</span>
          </div>
        </div>
      }
      @if (isSteamTrap() && !showRequiredHint()) {
        <div class="flex-container-info">
          <span><i nz-icon nzType="icons:info" class="svg-icon"></i></span>
          <div>
            <div class="bold-font">{{ i18n.langString("steam_loss_note") }}</div>
            <span>{{ i18n.langString("steam_loss_note_msg") }}</span>
          </div>
        </div>
      }

      <div class="buttonwrapper">
        <app-nav-button
          [primary]="true"
          [disabled]="formInValid()"
          (clickEvent)="saveEvent.emit()"
          [svgIcon]="'icons:save'"
        >
          {{ i18n.langString("save_information") }}
        </app-nav-button>
      </div>
    </div>
  </ng-template>
</nz-modal>
